var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.186,
    height: 42.186,
    viewBox: "0 0 504 504",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 151c56 0 101 45 101 101s-45 101-101 101-101-45-101-101 45-101 101-101z"
  })), /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#fefefe;stroke-width:13.5465}.fil1{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 252,
    r: 252,
    fill: "#201e1e"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 252,
    cy: 231,
    r: 39
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil1 str0",
    cx: 253,
    cy: 447,
    rx: 129,
    ry: 150
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M252 151c56 0 101 45 101 101s-45 101-101 101-101-45-101-101 45-101 101-101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginVisitor);
export default __webpack_public_path__ + "static/media/login-visitor.6032fc59112108f216f70081137ebd66.svg";
export { ForwardRef as ReactComponent };